/**
 * Format currency based on country
 */
export function formatCurrency(country, value) {
  country = country.toLowerCase();
  let locale = country === 'au' ? 'en-AU' : (country === 'uk' ? 'en-GB' : '');
  let currency = country === 'au' ? 'AUD' : (country === 'uk' ? 'GBP' : '');
  return  new Intl.NumberFormat(locale, { maximumSignificantDigits: 10, style: 'currency', currency: currency }).format(value.toFixed());
}
  